import { createFileRoute } from '@tanstack/react-router';
import { ResourcesSection } from '@/features/Lesson/ResourcesSection';
import { useTopicDetail } from '@/lib/hooks/useLms';

export const Route = createFileRoute('/_student/courses/$batchId/topics/$topicId/resources')({
  component: ResourcesRoute,
});

function ResourcesRoute() {
  const { topicId } = Route.useParams();
  const { data: topic } = useTopicDetail(topicId);
  if (!topic) return null;
  return <ResourcesSection resources={topic.resources} />;
}
